import { IIconStyles, ITooltipHostStyles, mergeStyles } from '@fluentui/react';

// Foreground icon colour. Tokenised so monochrome icons invert on dark
// (light #323130 → dark #f3f2f1). Used only as a `color`/SVG `fill` value;
// var() resolves in inline style and mergeStyles. SVG components that need it
// as a presentation attribute use fill="currentColor" against this color.
export const defaultFontColor: string = "var(--db-fg, #323130)";

export const fluentSvgIconStyles: React.CSSProperties = {
    lineHeight: 0,
    display: "inline"
}

export const svgIconStyles: React.CSSProperties = {
    ...fluentSvgIconStyles,
    color: defaultFontColor,
    alignSelf: "center"
}

export const smallPadLeft: React.CSSProperties = {
    marginLeft: 3
}

export const flexTooltipHost: ITooltipHostStyles = {
    root: {
        display: "flex"
    }
}

export const fontIconStylesSmall = mergeStyles({
    fontSize: 12
});

export const fontIconStylesMedium = mergeStyles({
    fontSize: 16
});

export const fontIconStyles = mergeStyles({
    fontSize: 18
});

export const gridFontIconStyles = mergeStyles({
    color: defaultFontColor,
    fontSize: 18
});

export const gridFontIconStylesSmall = mergeStyles({
    color: defaultFontColor,
    fontSize: 12
});

export const homeBrandIconStyles = mergeStyles({
    marginLeft: 2,
    marginRight: 2,
    display: "flex"
});

export const homeFontIconStyles = mergeStyles({
    color: defaultFontColor,
    marginLeft: 2,
    marginRight: 2,
    fontSize: 18,
    display: "flex"
});

export const homeFontIconStylesMedium = mergeStyles({
    color: defaultFontColor,
    marginLeft: 2,
    marginRight: 2,
    fontSize: 16,
    display: "flex"
});

export const iconStyles: IIconStyles = {
    root: {
        color: defaultFontColor
    }
}

export const iconDisplayStyle: IIconStyles = {
    root: {
        display: "flex",
    }
}